// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1wgtt","large":"styles_large__sfL91"};